import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import common from './Common';
import loginInfo from './LoginInfo';
import gochis from './Gochis';
import deposits from './Deposits';
import gochiMenus from './GochiMenus';
import gochiChildFoodLists from './GochiChildFoodLists';
import shops from './Shop';
import preShops from './PreShops';
import unregisteredShops from './UnregisteredShops';
import users from './Users';
import groups from './Groups';
import groupGochiMenus from './GroupGochiMenus';
import identities from './Identity';
import messages from './Message';
import accounts from './Accounts';
import manageNotices from './ManageNotices';
import reports from './Reports';
import cognitoUser from './CognitoUser';
import stripeChargeEvents from './ChargeEvent';
import options from './Options';
import cities from './Cities';
import gochiMenusEvent from './GochiMenusEvent';
import groupBudgets from './GroupBudgets';
import gochiEvent from './GochiEventSetting';
import tickets from './Tickets';
import ticketsUsedByAdmin from './TicketsUsedByAdmin';
import ticketsGroup from './TicketsGroup';
import bookings from './Bookings';
import systems from './Systems';
import budgets from './Budgets';
import giftcard from './GiftCard';

const reducer = combineReducers({
  routing: routerReducer,
  commons: common,
  loginInfo,
  gochis,
  deposits,
  gochiMenus,
  gochiMenusEvent,
  gochiChildFoodLists,
  shops,
  preShops,
  unregisteredShops,
  users,
  groups,
  groupGochiMenus,
  identities,
  messages,
  accounts,
  manageNotices,
  reports,
  cognitoUser,
  stripeChargeEvents,
  options,
  cities,
  tickets,
  ticketsGroup,
  systems,
  budgets,
  bookings,
  giftcard,
  groupBudgets,
  gochiEvent,
  ticketsUsedByAdmin
});

export default reducer;
